(function () {
    'use strict';

    angular.module('app')
        .factory('DivisaTipoService', DivisaTipoService);

    /* @ngInject */
    function DivisaTipoService($resource) {
        return $resource('api/public/divisa/tipo', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();
